import { render, staticRenderFns } from "./CommercialVehicleValuation.vue?vue&type=template&id=9778c6ea&scoped=true"
import script from "./CommercialVehicleValuation.vue?vue&type=script&lang=js"
export * from "./CommercialVehicleValuation.vue?vue&type=script&lang=js"
import style0 from "./CommercialVehicleValuation.vue?vue&type=style&index=0&id=9778c6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9778c6ea",
  null
  
)

export default component.exports